<template>
    <div class="master-template-select-view-control multiselect-view-control">
        <ButtonGroup>
            <Button
                :class="{ active: masterTemplatesLibraryStore.viewMode === MultiviewMode.Grid }"
                @click="masterTemplatesLibraryStore.viewMode = MultiviewMode.Grid"
            >
                <Icon type="md-apps" />
            </Button>
            <Button
                :class="{ active: masterTemplatesLibraryStore.viewMode === MultiviewMode.List }"
                @click="masterTemplatesLibraryStore.viewMode = MultiviewMode.List"
            >
                <Icon type="md-list" />
            </Button>
        </ButtonGroup>
    </div>
</template>

<script lang="ts" setup>
import { MultiviewMode } from "@/enums/multiview";
import { useMasterTemplatesLibraryStore } from "@/store/pinia/masterTemplatesLibrary";

const masterTemplatesLibraryStore = useMasterTemplatesLibraryStore();
</script>

<style lang="scss">
@use "@style/variables" as *;

.multiselect-view-control {
    display: flex;
    flex-wrap: nowrap;

    .ivu-btn.active {
        z-index: 1;
    }
}

.master-template-select-view-control {
    margin-right: $spacing;
}
</style>
